// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M_9D","top":"styles_top__3W6uc"};